module.exports = __webpack_public_path__ + "img/m6.4913f673.jpg";